import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Table, Tag, Typography } from 'antd';
import { eventoService } from '../../services/api';
import { handleApiError } from '../../utils/apiError';

// Fase B.2 (corrigida): SOMENTE visualizacao/diagnostico -- nenhuma acao de
// confirmar/solicitar/aprovar/cobrar/editar aluno nesta fase (isso e
// Fase B.3+, ainda nao implementada). Calculo 100% dinamico no backend a
// cada abertura, nada e persistido aqui.
//
// Identidade da linha: id_matricula, NUNCA id_aluno -- cada Matricula
// elegivel e uma possibilidade INDEPENDENTE de inscricao. Um mesmo aluno
// com 2 matriculas elegiveis (ex.: Ballet e Circo) aparece em 2 linhas
// distintas -- isso e CORRETO e nao deve ser tratado como duplicata.
const STATUS_MATRICULA_COLORS = { ATIVA: 'green', PENDENTE: 'gold' };

const AlunosElegiveisModal = ({ open, evento, sessao, onClose }) => {
  const [matriculas, setMatriculas] = useState([]);
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(async () => {
    if (!sessao) return;
    setLoading(true);
    try {
      const resp = await eventoService.listAlunosElegiveisSessao(evento.id, sessao.id);
      setMatriculas(resp.data || []);
    } catch (err) {
      handleApiError(err, 'Erro ao carregar alunos elegíveis');
    } finally {
      setLoading(false);
    }
  }, [evento, sessao]);

  useEffect(() => {
    if (open) {
      carregar();
    }
  }, [open, carregar]);

  const columns = [
    { title: 'Aluno', dataIndex: 'nome_aluno', key: 'nome_aluno' },
    { title: 'Turma', dataIndex: 'turma_nome', key: 'turma_nome' },
    {
      title: 'Situação da matrícula',
      dataIndex: 'status_matricula',
      key: 'status_matricula',
      render: (statusMatricula) => (
        <Tag color={STATUS_MATRICULA_COLORS[statusMatricula] || 'default'}>{statusMatricula}</Tag>
      ),
    },
  ];

  return (
    <Modal
      title={sessao ? `Alunos elegíveis — ${sessao.nome}` : 'Alunos elegíveis'}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={650}
    >
      <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
        Cálculo acadêmico dinâmico, baseado nas turmas elegíveis configuradas. Cada linha
        representa uma matrícula elegível — um mesmo aluno com mais de uma matrícula elegível
        aparece mais de uma vez. Não representa inscrição nem participação confirmada.
      </Typography.Paragraph>
      <Table
        rowKey="id_matricula"
        size="small"
        loading={loading}
        dataSource={matriculas}
        columns={columns}
        pagination={false}
        locale={{ emptyText: 'Nenhuma matrícula elegível encontrada' }}
      />
    </Modal>
  );
};

export default AlunosElegiveisModal;
